// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const header: Styleguide["header"] = {
    isCompactHeader: false,
    backgroundColor: "menu.mainNavigation",
    linkColor: null as any,
    isDropShadow: true,
    borderTopWidth: 20,
    isFullWidth: true,
    fullWidthStylingType: null as any,
    fullWidthColor: null as any,
    fullWidthImage: null as any,
    fullWidthImageFocalPoint: null as any,
};

export default header;
